module.exports = new __parcel__URL__("Wmbf.9695fca6.jpeg").toString();